import { h } from '@stencil/core';
import { FlightCityInfo, FlightDateTime } from 'client/types';

interface FlightInfoProps {
  datetime: FlightDateTime;
  city: FlightCityInfo;
}

export default function FlightInfo({ datetime, city }: FlightInfoProps) {
  const hasPlusDays = typeof datetime.plusDays !== 'undefined';
  return (
    <div class="flight-info">
      <span class={{ 'date': true, 'plus-days': hasPlusDays }}>
        {hasPlusDays && <span>(+{datetime.plusDays})&nbsp; </span>}
        <p class="-eva-3-capitalize">{datetime.date.substring(0, datetime.date.length - 5).replace(/,/g, '.')}</p>
      </span>
      <p class="time-info">{datetime.time}</p>
      <p class="airport-code">{city.code}</p>
      <p class="city-name">{city.name}</p>
      <p class="airport-name">{city.airport}</p>
    </div>
  );
}
